<template>
    <app-input 
        :value="date"
        :size="size"
        class="app-date-picker"
        prefix-icon="icon-datepicker" />
</template>

<script>

import Flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

export default {
    name: 'app-date-picker',
    props: {
        value: {
            default: null,
            required: true,
            validator(value) {
                return value === null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof Array || typeof value === 'number'
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'date'
        },
        availableDates: {
            type: Array
        },
        size: String
    },
    data() {
        return {
            date: null,
            fp: null,
            config: {
                allowInput: true,
                dateFormat: 'm/d/Y'
            }
        }
    },
    computed: {
        enableTime() {
            return this.type == 'datetime'
        },
        mode() {
            return this.type == 'daterange' ? 'range' : 'single'
        }
    },
    mounted() {
        if (this.fp) return

        this.config.defaultDate = this.value
        this.config.enableTime = this.enableTime
        this.config.dateFormat = this.enableTime ? 'm/d/Y H:i' : 'm/d/Y'
        this.config.mode = this.mode
        this.config.onChange = (selectedDates, str) => {
            if (this.type == 'daterange') {
                if (selectedDates.length > 1) {
                    this.$emit('input', selectedDates)
                }
            }
            else {
                this.$emit('input', selectedDates[0])
            }
            this.date = str
        }
        if (this.availableDates) {
            this.config.enable = [(date) => {
                const formattedDate = moment(date).format('YYYY-MM-DD')
                const enabledDates = this.availableDates
                return enabledDates.indexOf(formattedDate) > -1
            }]
        }

        const input = this.elem()
        this.fp = new Flatpickr(input, this.config)

        this.fpInput().addEventListener('blur', this.onBlur)
    },
    beforeDestroy() {
        if (this.fp) {
            this.fpInput().removeEventListener('blur', this.onBlur)
            this.fp.destroy()
            this.fp = null
        }
    },
    methods: {
        elem() {
            return this.$children[0].$refs.input
        },
        fpInput() {
            return this.fp.altInput || this.fp.input
        },
        onBlur(event) {
            this.$emit('blur', event.target.value)
        }
    },
    watch: {
        value(newValue) {
            if (!this.fp) return
            if (this.fp.selectedDates.length > 0) {
                if (newValue == this.fp.selectedDates || newValue === this.fp.selectedDates[0]) return
            }
            this.fp.setDate(newValue, true)
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'
.flatpickr-calendar
    .flatpickr-day
        font-weight: 500
        margin-top: 3px
        &.today
            border-color: $dark-blue
            &:hover
                background: $dark-blue
                border-color: $dark-blue
        &.selected
            background: $dark-blue
            border-color: $dark-blue
            font-weight: 700
        &.endRange,
        &.startRange
            border-radius: 50px
        &.startRange::before,
        &.endRange::before
            content: ''
            background: $lighter-grey
            position: absolute
            top: -1px
            bottom: -1px
            z-index: -1
        &.startRange::before
            border-radius: 50px 0 0 50px
            right: -1px
            left: 0
        &.endRange::before
            border-radius: 0 50px 50px 0
            right: 0
            left: -1px
        &.inRange
            background: $lighter-grey
            box-shadow: -5px 0 0 $lighter-grey, 5px 0 0 $lighter-grey
            border-color: $lighter-grey

    .flatpickr-current-month
        display: flex
        justify-content: center
        align-items: center
        .flatpickr-monthDropdown-months,
        input.cur-year
            font-size: 16px
            font-family: sans-serif
            font-weight: 700
            text-align: center
            border-radius: 5px
            color: #444
            padding: 2px 10px
        input.cur-year
            padding-right: 20px
        .numInputWrapper
            border-radius: 5px
            min-width: 80px
        .flatpickr-monthDropdown-months
            margin: 0
            -moz-appearance: none
            -webkit-appearance: none
            appearance: none
            background-color: #fff
</style>